import React, { useEffect, useState } from 'react'
import './index.scss'
import PaymentService from '../../services/paymentService'
import { CURRENT_APP_MODE_CONFIG } from '../../constants/appMode'
export const PAYMENT_TYPE_CODE = {
  ATM_BANK: 'ATM_BANK',
  MOMO: 'MOMO',
  GTEL_PAY: 'GTELPAY',
  VNPAY: 'VNPAY',
  ZALOPAY: 'ZALOPAY',
  VIETTEL_PAY: 'VIETTEL_PAY',
  TA_MOVE: 'TA_MOVE'
}

// Kiểm tra nếu là TaMove thì sẽ ẩn ngân hàng, nếu là Ngân hàng thì sẽ ẩn tamove
export const PAYMENT_METHOD_ID_SHOW_HIDE_WITH_THEME = {
  bank: {
    value: 'bank',
    paymentTypeCode: PAYMENT_TYPE_CODE.ATM_BANK,
    theme: ['TTDK', 'DKON', 'VIPMEMBER', 'IHANOI']
  },
  TAMove: {
    value: 'TAMove',
    paymentTypeCode: PAYMENT_TYPE_CODE.TA_MOVE,
    theme: ['TAMOVE']
  },
  gtelPay: {
    value: 'gtelPay',
    paymentTypeCode: PAYMENT_TYPE_CODE.GTEL_PAY,
    theme: ['TTDK', 'DKON', 'VIPMEMBER']
  },
  zaloPay: {
    value: 'zaloPay',
    paymentTypeCode: PAYMENT_TYPE_CODE.ZALOPAY,
    theme: ['TTDK', 'DKON', 'VIPMEMBER']
  },
  vnpay: {
    value: 'vnpay',
    paymentTypeCode: PAYMENT_TYPE_CODE.VNPAY,
    theme: ['TTDK', 'DKON', 'VIPMEMBER', 'TAMOVE']
  }
}

export const checkShowPaymentMethodWithTheme = (paymentMethods = []) => {
  const CURRENT_THEME = CURRENT_APP_MODE_CONFIG.paymentTheme

  return paymentMethods.filter((method) => {
    const isVnpayInApp =
      Number(method?.paymentMethodId) === 13 ||
      Number(method?.paymentMethodType) === 13 ||
      method?.paymentTypeCode === 'VNPAY_INAPP' ||
      method?.paymentMethodName?.toUpperCase?.()?.includes('VNPAY INAPP')

    if (isVnpayInApp) {
      return false
    }

    const config = Object.values(PAYMENT_METHOD_ID_SHOW_HIDE_WITH_THEME).find(
      (item) => item.paymentTypeCode === method.paymentTypeCode
    )

    if (!config) return true

    return config.theme.includes(CURRENT_THEME)
  })
}

const PaymentMethodSelection = ({ paymentMethod, setPaymentMethod, setListPaymentMethod = () => {} }) => {
  const [data, setData] = useState({})

  const allowedPaymentMethods = [PAYMENT_TYPE_CODE.ATM_BANK, PAYMENT_TYPE_CODE.GTEL_PAY, PAYMENT_TYPE_CODE.TA_MOVE]

  useEffect(() => {
    ;(async () => {
      try {
        const paymentData = await PaymentService.getPaymentQRMethod({})
        const dataConverted = Object.fromEntries(
          checkShowPaymentMethodWithTheme(Object.values(paymentData)).map((item) => [item.paymentMethodId, item])
        )
        setData(dataConverted)
        setListPaymentMethod(dataConverted)
      } catch (err) {
        console.log('fail to get payment methods')
      }
    })()
  }, [])

  return (
    <div className="payment-method-selection">
      <h6 className="mb-0">Phương thức thanh toán</h6>
      <div style={{ color: 'var(--brand-primary)' }}>Vui lòng chọn 1 hình thức</div>

      <div className="mt-3">
        <div className="d-flex flex-row gap-3 align-items-center flex-wrap">
          {Object.values(data).length > 0 &&
            Object.values(data)?.map(
              (item) =>
                item?.paymentMethodEnable === 1 &&
                allowedPaymentMethods.includes(item?.paymentTypeCode) && (
                  <div
                    key={item?.paymentMethodId}
                    onClick={() => setPaymentMethod(item?.paymentMethodId)}
                    className={`payment-method-selection-item py-3 d-flex flex-column align-items-center justify-content-center gap-3 bg-white ${
                      Object.values(data)?.length === 1 ? 'w-100' : ''
                    } ${paymentMethod === item?.paymentMethodId ? 'active' : ''}`}>
                    <img
                      height={item?.paymentMethodName === 'ZaloPay' ? 50 : 30}
                      src={item?.paymentMethodImageUrl}
                      alt={item?.paymentMethodReferName}
                    />
                    <div>{item?.paymentMethodName}</div>
                  </div>
                )
            )}
        </div>
      </div>
    </div>
  )
}

export default PaymentMethodSelection
